export const monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

export const getMonth = (month = 0) => {
  const d = (new Date().getMonth())%12 + month;
  return monthArray[d];
}
